import { ActivityItemsResponse } from '@yarmill/types';
import { axios } from '@yarmill/utils';
import { AxiosPromise } from 'axios';

export function getActivityItems(): AxiosPromise<ActivityItemsResponse> {
  return axios.get('api/ActivityItemV3');
}
